// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var APINews = require("./Components/News/APINews.js");

APINews.renderByQuery(".una-reason__news");

/*  Not a pure module */
